
  import {mapGetters} from 'vuex'
  import TrackComponent from "../common/TrackComponent";
  import Observer from "../common/ObserverComponent";

  export default {
    name: "AuthorSlugPageView",
    components: {Observer, TrackComponent},
    props: {},
    data() {
      return {
        detailsDict: {
          about: 'О себе',
          genres: 'Жанры',
          instruments: 'Инструменты',
        }
      }
    },
    computed: {
      ...mapGetters('tracks', ['trackList', 'nextPage']),
      ...mapGetters('author', ['author']),
    },
    methods: {
      getDetailsAuthor(key) {
        return Array.isArray(this.author[key]) ? this.author[key].join(', ') : this.author[key]
      },
      async intersected() {
        if (this.nextPage) {
          await this.$store.dispatch('author/loadingAuthorTracks', {page: this.nextPage, slug: this.$route.params.slug })
        }
      },
    }
  }
